import { Channel } from '@/Enums/Channel.enum';
import DoohVenueTypeLevel from '@/Enums/Dooh/VenueTypeLevel.enum';
import { IImpressionCalculation } from '@/Interfaces/Forecaster';
import Impressions from '@/components/Forecast/Estimation/Impressions';
import { LOADING } from '@/constants/forecaster';
import { downloadTableCsv } from '@/helpers/downloadCSV';
import { numberToUsFormat } from '@/helpers/valueFormatter/numberFormatter.helpers';
import { useCallback, useState } from 'react';
import EstimationDatePicker from '../components/EstimationDatePicker';
import InfoSection from '../components/InfoSection';
import VenueTypeView from './VenueTypeView';

interface IProps {
  data: IImpressionCalculation | null;
  label: string;
  showDatePicker?: boolean;
  currentChannel?: Channel;
}

const DoohTab = ({ data, label, showDatePicker, currentChannel }: IProps) => {
  const [openVenueTypeView, setOpenVenueTypeView] = useState<boolean>(false);
  const onVenueViewClick = useCallback(() => {
    setOpenVenueTypeView(true);
  }, []);

  const onVenueViewClose = useCallback(() => {
    setOpenVenueTypeView(false);
  }, []);

  const onVenueViewDownload = useCallback(() => {
    let lastParent: string = '';
    let lastChild: string = '';
    const csvData = (data?.venueTypes ?? []).map(record => {
      const { name: category, level } = record;
      if (level === DoohVenueTypeLevel.Parent) {
        lastParent = category;
        lastChild = '';
      } else if (level === DoohVenueTypeLevel.Child) {
        lastChild = category;
      }

      const grandchild = level === DoohVenueTypeLevel.Grandchild ? category : '';
      return { ['Parent Category']: lastParent, ['Child Category']: lastChild, ['Grandchild Category']: grandchild };
    });
    downloadTableCsv(csvData, `Available_Venue_Types_${Date.now()}`);
  }, [data?.venueTypes]);

  return (
    <>
      <div className='flex w-full h-full flex-col gap-3 justify-evenly items-center'>
        {showDatePicker ? <EstimationDatePicker /> : null}
        <Impressions
          tabName={`${label} DOoH`}
          value={data ? numberToUsFormat(data.impressions) : LOADING}
          currentChannel={currentChannel}
        />
        <InfoSection label='Number of screens' value={data ? numberToUsFormat(data.numberOfScreens ?? 0) : LOADING} />
        <InfoSection
          label='Venue Types Available'
          value={data ? data.venueTypesCount : LOADING}
          onView={data ? onVenueViewClick : undefined}
          onDownload={data ? onVenueViewDownload : undefined}
        />
        <InfoSection
          label='Estimated Floor Price'
          value={data ? `$${data.estimatedFloorPrice?.min} - $${data.estimatedFloorPrice?.max} USD` : LOADING}
        />
      </div>
      <VenueTypeView onClose={onVenueViewClose} open={openVenueTypeView} venueTypes={data?.venueTypes ?? []} />
    </>
  );
};

export default DoohTab;
